import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const user = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js